module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN2.bae58ded.png";